<template>
  <el-container class="voucher">
    <el-header class="header-style">
      <el-divider content-position="left">凭证交接</el-divider>
      <el-row>
        <el-col :span="4">
          <el-col :span="23">
            <el-select
              v-model="searchArr.cid"
              filterable
              remote
              reserve-keyword
              placeholder="请输入公司字号筛选公司"
              size="mini"
              clearable
              @change="handleCompanyChange"
              :remote-method="remoteCompanyMethod"
              :loading="loading"
            >
              <el-option
                v-for="company in companies"
                :key="company.id"
                :label="company.company_name"
                :value="company.id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-col>
        <el-col :span="4">
          <el-col :span="23">
            <el-date-picker
              v-model="searchArr.dateTime"
              type="month"
              size="mini"
              format="yyyy 年 MM 月"
              value-format="yyyy-MM"
              :picker-options="pickerOptions"
              @change="handleDateTimeChange"
              placeholder="选择月份"
            >
            </el-date-picker>
          </el-col>
        </el-col>
        <el-col :span="4">
          <el-col :span="23">
            <el-select
              collapse-tags
              v-model="searchArr.is_connect"
              placeholder="请选择通知状态"
              @change="handleCompanyChange"
              size="mini"
              clearable
            >
              <el-option :value="1" label="已上传"></el-option>
              <el-option :value="2" label="未上传"></el-option>
              <el-option :value="3" label="已交接"></el-option>
              <el-option :value="4" label="未交接"></el-option>
            </el-select>
          </el-col>
        </el-col>
        <el-col :span="1">
          <el-col :span="22">
            <el-popover placement="bottom-start" v-model="searchVisible" width="320">
              <el-row style="margin-bottom: 0.4rem; padding-top: 0.5rem">
                <el-col :span="6" style="margin-top: 0.1rem">理票会计：</el-col>
                <el-col :span="18">
                  <el-cascader
                    v-model="searchArr.acc_id"
                    placeholder="请选择理票会计"
                    :options="allusersAddition"
                    size="mini"
                    :props="{ expandTrigger: 'hover' }"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">记账报税会计：</el-col>
                <el-col :span="18">
                  <el-cascader
                    v-model="searchArr.advisory_id"
                    placeholder="请选择记账报税会计"
                    :options="allusersAddition"
                    size="mini"
                    :props="{ expandTrigger: 'hover' }"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">客服会计：</el-col>
                <el-col :span="18">
                  <el-cascader
                    v-model="searchArr.ass_id"
                    placeholder="请选择客服会计"
                    :options="allusersAddition"
                    size="mini"
                    :props="{ expandTrigger: 'hover' }"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">开票会计：</el-col>
                <el-col :span="18">
                  <el-cascader
                    v-model="searchArr.invoice_id"
                    placeholder="请选择开票会计"
                    :options="allusersAddition"
                    size="mini"
                    :props="{ expandTrigger: 'hover' }"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">财税负责人：</el-col>
                <el-col :span="18">
                  <el-cascader
                    v-model="searchArr.leader_id"
                    placeholder="请选择财税负责人"
                    :options="allusersAddition"
                    size="mini"
                    :props="{ expandTrigger: 'hover' }"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">所属业务：</el-col>
                <el-col :span="18">
                  <el-cascader
                    v-model="searchArr.saler_id"
                    placeholder="请选择所属业务"
                    :options="allusersAddition"
                    size="mini"
                    :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">是否绑定：</el-col>
                <el-col :span="18">
                  <el-radio-group v-model="searchArr.is_bind" size="mini">
                    <el-radio label="1" border>未绑定</el-radio>
                    <el-radio label="2" border>已绑定</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">是否关注：</el-col>
                <el-col :span="18">
                  <el-radio-group v-model="searchArr.is_subscribe" size="mini">
                    <el-radio label="1" border>未关注</el-radio>
                    <el-radio label="2" border>已关注</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">有无档案：</el-col>
                <el-col :span="18">
                  <el-radio-group v-model="searchArr.archives" size="mini">
                    <el-radio label="1" border>有档案</el-radio>
                    <el-radio label="2" border>无档案</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="12" :offset="12">
                  <el-button size="mini" @click="handleClearSearchGetData"
                    >清除</el-button
                  >
                  <el-button type="primary" @click="handleSearchGetData" size="mini"
                    >查询</el-button
                  >
                </el-col>
              </el-row>
              <el-button slot="reference" size="mini">筛选</el-button>
            </el-popover>
          </el-col>
          <el-col :span="1">
            <el-upload action="#" :headers="uploadHeader" :http-request="submitBind">
              <el-button size="mini" style="margin-left: 0.4rem">导入</el-button>
            </el-upload>
          </el-col>
        </el-col>
        <el-col :span="1">
          <el-button
            type="warning"
            style="margin-left: 1.6rem"
            size="mini"
            @click="vForExport"
            >导出</el-button
          >
        </el-col>
      </el-row>
      <el-row style="margin: 0.2rem 0">
        <el-col> 日期：{{ list_month }} </el-col>
      </el-row>
    </el-header>

    <el-main class="main-style">
      <el-table height="calc(100vh - 266px)" :data="pageData" :show-overflow-tooltip="true" style="width: 100%" border>
        <el-table-column label="公司名称" width="350" fixed>
          <template slot-scope="scope">
            <el-tooltip
              :content="scope.row.company_name"
              placement="top"
              style="display: inline-block; vertical-align: middle"
            >
              <div class="company_hover">
                <span class="count_style" style="display: inherit">
                  <el-link
                    type="primary"
                    @click="
                      handleOpen(
                        scope.row.id,
                        scope.row.company_name,
                        scope.row,
                        'second'
                      )
                    "
                    >{{ scope.row.company_name }}</el-link
                  >
                </span>
              </div>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="复制" placement="top"
              ><i
                class="el-icon-document-copy"
                style="margin-left: 0.1rem; cursor: pointer"
                @click="copySome(scope.row.company_name)"
              ></i
            ></el-tooltip>
          </template>
        </el-table-column>
        <!-- <el-table-column label="月份" width="100" fixed>
        <template slot-scope="scope">
          <el-tooltip
            :content="
              scope.row.voucher_state.length > 0
                ? scope.row.voucher_state[0].month
                : list_month
            "
            placement="top"
          >
            <span class="hide-style">{{
              scope.row.voucher_state.length > 0
                ? scope.row.voucher_state[0].month
                : list_month
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column> -->
        <el-table-column label="是否上传凭证" width="120">
          <template slot-scope="scope">
            <el-tooltip
              :content="scope.row.voucher_list.length > 0 ? '已上传' : '未上传'"
              placement="top"
            >
              <span
                v-if="scope.row.voucher_list.length > 0"
                class="hide-style"
                style="color: #67c23a"
                >{{ scope.row.voucher_list.length > 0 ? "已上传" : "未上传" }}</span
              >
              <span v-else class="hide-style" style="color: red">{{
                scope.row.voucher_list.length > 0 ? "已上传" : "未上传"
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="是否交接凭证" width="120">
          <template slot-scope="scope">
            <el-tooltip
              :content="
                scope.row.voucher_state.length > 0
                  ? scope.row.voucher_state[0].is_connect === 2
                    ? '已交接'
                    : '未交接'
                  : '未交接'
              "
              placement="top"
            >
              <span
                v-if="
                  scope.row.voucher_state.length > 0 &&
                  scope.row.voucher_state[0].is_connect === 2
                "
                class="hide-style"
                style="color: #67c23a"
                >已交接</span
              >
              <span v-else class="hide-style" style="color: red">未交接</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="用户名称" width="120">
          <template slot-scope="scope">
            <!-- <el-tooltip :content="scope.row.user ?  scope.row.user.name : ''" placement="top">
            <span class="hide-style">{{ scope.row.user ?  scope.row.user.name : '' }}</span>
          </el-tooltip> -->
            <el-link
              type="primary"
              :underline="false"
              style="padding: 0; border: none"
              slot="reference"
              @click="handleShowPayerContent(scope.row)"
              >{{ scope.row.user ? scope.row.user.name : "" }}</el-link
            >
          </template>
        </el-table-column>
        <el-table-column label="是否关注公众号" width="120">
          <template slot-scope="scope">
            <el-tooltip
              :content="
                scope.row.oauth
                  ? scope.row.oauth.subscribe === 1
                    ? '已关注'
                    : '未关注'
                  : '未关注'
              "
              placement="top"
            >
              <span class="hide-style">{{
                scope.row.oauth
                  ? scope.row.oauth.subscribe === 1
                    ? "已关注"
                    : "未关注"
                  : "未关注"
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="代账软件" width="120">
          <template slot-scope="scope">
            <el-tooltip
              :content="
                scope.row.com_fiscal_tax
                  ? scope.row.com_fiscal_tax.software_types
                    ? scope.row.com_fiscal_tax.software_types === 1
                      ? '17DZ'
                      : scope.row.com_fiscal_tax.software_types === 2
                      ? '云账房'
                      : scope.row.com_fiscal_tax.software_types === 3
                      ? '易代账'
                      : '其他'
                    : '未知'
                  : '无服务'
              "
              placement="top"
            >
              <span class="hide-style">{{
                scope.row.com_fiscal_tax
                  ? scope.row.com_fiscal_tax.software_types
                    ? scope.row.com_fiscal_tax.software_types === 1
                      ? "17DZ"
                      : scope.row.com_fiscal_tax.software_types === 2
                      ? "云账房"
                      : scope.row.com_fiscal_tax.software_types === 3
                      ? "易代账"
                      : "其他"
                    : "未知"
                  : "无服务"
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="凭证上传/凭证上传人员" width="300">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center">
              <el-tooltip
                content="上传图片"
                placement="top"
                v-if="scope.row.voucher_list.length <= 0"
              >
                <el-button
                  type="success"
                  size="mini"
                  icon="el-icon-upload2"
                  @click="handleUploadImg(scope.row, scope.$index, 5)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-tooltip
                content="查看图片"
                placement="top"
                v-if="scope.row.voucher_list.length > 0"
              >
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-picture-outline"
                  @click="handleOpen(scope.row.id, scope.row.company_name, scope.$index)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-avatar
                v-if="scope.row.voucher_list.length > 0"
                style="
                  margin-right: 0.2rem;
                  width: 28px;
                  height: 28px;
                  margin-left: 0.2rem;
                "
                :src="
                  scope.row.voucher_list.length > 0
                    ? imgPath + scope.row.voucher_list[0].admin.icon
                    : scope.row.voucher_list[0]
                    ? imgPath + scope.row.voucher_list[0].admin.icon
                    : ''
                "
              >
              </el-avatar>
              <el-tooltip
                :content="
                  scope.row.voucher_list.length > 0
                    ? scope.row.voucher_list[0].admin.username +
                      ' ' +
                      scope.row.voucher_list[0].created_at
                    : ''
                "
                placement="top"
              >
                <div>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{
                      scope.row.voucher_list.length > 0
                        ? scope.row.voucher_list[0].admin.username
                        : ""
                    }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{
                      scope.row.voucher_list.length > 0
                        ? scope.row.voucher_list[0].created_at
                        : ""
                    }}
                  </span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="300">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="凭证交接" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-s-order"
                @click="
                  handleOpen(scope.row.id, scope.row.company_name, scope.row, 'second')
                "
                :disabled="
                  scope.row.voucher_state.length > 0 &&
                  scope.row.voucher_state[0].is_connect === 2
                "
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="财税建议" placement="top">
              <el-button
                type="primary"
                @click="handleOpenAdvice(scope.row.id, scope.row.company_name)"
                size="mini"
                icon="el-icon-reading"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="聊天记录" placement="top">
              <el-button
                type="primary"
                :disabled="scope.row.chat_com ? false : true"
                @click="handleChatOpen(scope.row.chat_com, scope.row.company_name)"
                size="mini"
                icon="el-icon-s-comment"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="企业微信群聊天记录"
              placement="top"
            >
              <el-button
                type="warning"
                :disabled="scope.row.wx_work_chat_com ? false : true"
                @click="
                  handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.company_name)
                "
                size="mini"
                icon="el-icon-s-comment"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="企友聊天记录" placement="top">
              <el-button
                type="success"
                :disabled="scope.row.qy_chat_com ? false : true"
                size="mini"
                icon="el-icon-s-comment"
                @click="handleQyChatOpen(scope.row.qy_chat_com, scope.row.company_name)"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-phone-outline
"
                :disabled="scope.row.user ? false : true"
                circle
                @click="handCallLogsOpen(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination
        background
        class="pagination-style"
        layout="total, sizes, prev, pager, next, jumper"
        :hide-on-single-page="false"
        :current-page="pageOption.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize"
        :total="pageOption.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-footer>

    <el-drawer
      title="财税建议"
      :visible.sync="categoryIndrawer"
      direction="rtl"
      :before-close="handleCloseIn"
      size="50%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -10px">
        <tax-advice :comId="adviceComId" :comName="adviceComName"></tax-advice>
      </div>
    </el-drawer>
    <el-drawer
      :title="'凭证上传【' + companyName + '】'"
      :visible.sync="uploadingDrawer"
      :before-close="handleAddClose"
      size="40%"
    >
      <div class="drawer-content">
        <el-form
          :model="addForm"
          :rules="addRules"
          ref="addForm"
          label-width="100px"
          size="mini"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="月份" prop="month">
                <el-date-picker
                  v-model="addForm.month"
                  type="month"
                  size="mini"
                  width="100%"
                  readonly
                  format="yyyy 年 MM 月"
                  value-format="yyyy-MM"
                  @change="pickerDataChangeUpload"
                  placeholder="选择月"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注" prop="user_remark">
            <el-input
              v-model="addForm.remark"
              type="textarea"
              placeholder="请输入需要告知客户的信息(若无 可不填写)"
            />
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="24">
            <el-card shadow="hover">
              <el-upload
                multiple
                ref="upload"
                action="#"
                accept="image/png, image/jpeg, image/gif"
                :limit="5"
                :on-preview="handleLicensePreview"
                :on-change="handleLicenseChange"
                :on-remove="handleLicenseRemove"
                :file-list="licenseList"
                list-type="picture"
                :auto-upload="false"
              >
                <el-link slot="trigger" type="primary">上传截图(最多可上传5张)</el-link>
              </el-upload>
            </el-card>
          </el-col>
        </el-row>
        <el-row class="mt-10">
          <el-input
            v-paste="handleParse"
            type="textarea"
            placeholder="请点击此处，再粘贴复制的截图"
          />
        </el-row>
        <el-row class="mt-10">
          <el-col :span="24" class="text-r">
            <el-button type="primary" size="mini" @click="submitAddUpload('addForm')"
              >添加</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      :title="'服务详情【' + companyName + '】'"
      :visible.sync="serviceDrawer"
      direction="rtl"
      size="45%"
      fullscreen
    >
      <div style="margin-left: 0.4rem">
        <div class="m-tabs-content">
          <div class="blocka">
            <el-tabs v-model="showTabPane" type="border-card">
              <el-tab-pane label="服务记录" name="first">
                <el-collapse
                  v-model="activeName"
                  v-for="(records, index) in infoRecord"
                  :key="index"
                  accordion
                  style="border-bottom: 1px solid #ebeef5"
                >
                  <el-collapse-item
                    :title="records.month + ' 凭证服务详情'"
                    :name="index + 1"
                  >
                    <el-timeline>
                      <el-timeline-item
                        :timestamp="item.created_at"
                        v-for="(item, index) in records.record"
                        :key="index"
                        placement="top"
                      >
                        <el-card>
                          <h4>
                            <el-row>
                              <el-col :span="20">
                                {{
                                  (item.admin
                                    ? item.admin.username
                                    : item.user.username) +
                                  (item.type === 2
                                    ? "上传了凭证"
                                    : item.type === 3
                                    ? "以 " +
                                      (item.connect_type ? item.connect_type : "") +
                                      " 的方式交接了 " +
                                      (item.connect_months ? item.connect_months : "") +
                                      " 的凭证"
                                    : "")
                                }}
                              </el-col>
                            </el-row>
                          </h4>
                          <span v-if="item.express">
                            <el-collapse>
                              <el-row style="margin-bottom: 0">
                                <el-col :span="6">快递状态：</el-col>
                                <el-col
                                  :span="5"
                                  style="color: #4c87fc; font-weight: bold"
                                  >{{
                                    item.express.accept_status
                                      ? item.express.accept_status
                                      : "暂无状态"
                                  }}</el-col
                                >
                                <el-col :span="11" :offset="2">
                                  <el-tooltip content="点击复制快递单号" placement="top">
                                    <span
                                      class="count_style"
                                      style="
                                        display: inherit;
                                        color: orange;
                                        cursor: pointer;
                                      "
                                      @click="copyStr(item.express.exp_num)"
                                      >{{
                                        item.express ? item.express.exp_num : ""
                                      }}</span
                                    >
                                  </el-tooltip>
                                </el-col>
                              </el-row>
                              <el-collapse-item title="快递信息（点此展开）">
                                <div class="block">
                                  <el-timeline>
                                    <el-timeline-item
                                      v-for="(item, index) in item.express.content"
                                      :key="index"
                                      :timestamp="item.time"
                                    >
                                      {{ item.status }}
                                    </el-timeline-item>
                                  </el-timeline>
                                </div>
                              </el-collapse-item>
                            </el-collapse>
                          </span>
                          <span v-if="item.images">
                            <span v-for="(imgUrl, index) in item.images" :key="index">
                              <el-image
                                class="image"
                                :src="imgUrl"
                                :preview-src-list="item.images"
                                v-if="item.images"
                                style="margin-right: 0.1rem"
                              ></el-image>
                            </span>
                          </span>
                          <p v-if="item.remark">
                            {{
                              (item.type === 3 ? "交接内容：" : "备注：") + item.remark
                            }}
                          </p>
                          <p v-if="!item.remark">
                            {{ item.type === 3 ? "交接内容：无" : "备注：无" }}
                          </p>
                        </el-card>
                      </el-timeline-item>
                    </el-timeline>
                  </el-collapse-item>
                </el-collapse>
              </el-tab-pane>
              <el-tab-pane label="凭证交接" name="second">
                <el-divider content-position="left"
                  ><span class="top-line">凭证交接信息</span></el-divider
                >
                <el-row>
                  <el-col :span="24" class="m-label">
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="公司名称" placement="top">
                        <span class="count_style" style="display: inherit"
                          >公司名称：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="15" class="m-label">
                      <span>{{ companyName }}</span>
                    </el-col>
                  </el-col>
                  <el-col :span="24">
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="交接年份" placement="top">
                        <span class="count_style" style="display: inherit"
                          >交接年份：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-col :span="11">
                        <el-date-picker
                          v-model="addVoucher.year"
                          type="year"
                          size="mini"
                          format="yyyy 年"
                          :picker-options="pickerOptions"
                          @change="handleChangeYear"
                          value-format="yyyy"
                          placeholder="选择年"
                        >
                        </el-date-picker>
                      </el-col>
                    </el-col>
                  </el-col>
                  <el-col :span="24" class="m-label">
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="交接月份" placement="top">
                        <span class="count_style" style="display: inherit"
                          >交接月份：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-col :span="24" class="m-label">
                        <el-checkbox-group v-model="addVoucher.months">
                          <el-col :span="24" class="col-margin">
                            <el-col :span="7">
                              <el-checkbox
                                label="01"
                                v-if="noUpload.indexOf('01') !== -1"
                                border
                                :disabled="noUpload.indexOf('01') !== -1"
                                ><span class="no_upload">1月（未上传）</span></el-checkbox
                              >
                              <el-checkbox
                                label="01"
                                v-if="noConnect.indexOf('01') !== -1"
                                border
                                :disabled="noConnect.indexOf('01') !== -1"
                                ><span class="uploaded">1月（已交接）</span></el-checkbox
                              >
                              <el-checkbox
                                label="01"
                                v-if="canConnect.indexOf('01') !== -1"
                                border
                                style="color: #67c23a"
                                >1月（待交接）</el-checkbox
                              >
                            </el-col>
                            <el-col :span="7" :offset="1">
                              <el-checkbox
                                label="02"
                                v-if="noUpload.indexOf('02') !== -1"
                                border
                                :disabled="noUpload.indexOf('02') !== -1"
                                ><span class="no_upload">2月（未上传）</span></el-checkbox
                              >
                              <el-checkbox
                                label="02"
                                v-if="noConnect.indexOf('02') !== -1"
                                border
                                :disabled="noConnect.indexOf('02') !== -1"
                                ><span class="uploaded">2月（已交接）</span></el-checkbox
                              >
                              <el-checkbox
                                label="02"
                                v-if="canConnect.indexOf('02') !== -1"
                                border
                                style="color: #67c23a"
                                >2月（待交接)</el-checkbox
                              >
                            </el-col>
                            <el-col :span="7" :offset="1">
                              <el-checkbox
                                label="03"
                                v-if="noUpload.indexOf('03') !== -1"
                                border
                                :disabled="noUpload.indexOf('03') !== -1"
                                ><span class="no_upload">3月（未上传）</span></el-checkbox
                              >
                              <el-checkbox
                                label="03"
                                v-if="noConnect.indexOf('03') !== -1"
                                border
                                :disabled="noConnect.indexOf('03') !== -1"
                                ><span class="uploaded">3月（已交接）</span></el-checkbox
                              >
                              <el-checkbox
                                label="03"
                                v-if="canConnect.indexOf('03') !== -1"
                                border
                                style="color: #67c23a"
                                >3月（待交接)</el-checkbox
                              >
                            </el-col>
                          </el-col>
                          <el-col :span="24" class="col-margin">
                            <el-col :span="7">
                              <el-checkbox
                                label="04"
                                v-if="noUpload.indexOf('04') !== -1"
                                border
                                :disabled="noUpload.indexOf('04') !== -1"
                                ><span class="no_upload">4月（未上传）</span></el-checkbox
                              >
                              <el-checkbox
                                label="04"
                                v-if="noConnect.indexOf('04') !== -1"
                                border
                                :disabled="noConnect.indexOf('04') !== -1"
                                ><span class="uploaded">4月（已交接）</span></el-checkbox
                              >
                              <el-checkbox
                                label="04"
                                v-if="canConnect.indexOf('04') !== -1"
                                border
                                style="color: #67c23a"
                                >4月（待交接)</el-checkbox
                              >
                            </el-col>
                            <el-col :span="7" :offset="1">
                              <el-checkbox
                                label="05"
                                v-if="noUpload.indexOf('05') !== -1"
                                border
                                :disabled="noUpload.indexOf('05') !== -1"
                                ><span class="no_upload">5月（未上传）</span></el-checkbox
                              >
                              <el-checkbox
                                label="05"
                                v-if="noConnect.indexOf('05') !== -1"
                                border
                                :disabled="noConnect.indexOf('05') !== -1"
                                ><span class="uploaded">5月（已交接）</span></el-checkbox
                              >
                              <el-checkbox
                                label="05"
                                v-if="canConnect.indexOf('05') !== -1"
                                border
                                style="color: #67c23a"
                                >5月（待交接)</el-checkbox
                              >
                            </el-col>
                            <el-col :span="7" :offset="1">
                              <el-checkbox
                                label="06"
                                v-if="noUpload.indexOf('06') !== -1"
                                border
                                :disabled="noUpload.indexOf('06') !== -1"
                                ><span class="no_upload">6月（未上传）</span></el-checkbox
                              >
                              <el-checkbox
                                label="06"
                                v-if="noConnect.indexOf('06') !== -1"
                                border
                                :disabled="noConnect.indexOf('06') !== -1"
                                ><span class="uploaded">6月（已交接）</span></el-checkbox
                              >
                              <el-checkbox
                                label="06"
                                v-if="canConnect.indexOf('06') !== -1"
                                border
                                style="color: #67c23a"
                                >6月（待交接)</el-checkbox
                              >
                            </el-col>
                          </el-col>
                          <el-col :span="24" class="col-margin">
                            <el-col :span="7">
                              <el-checkbox
                                label="07"
                                v-if="noUpload.indexOf('07') !== -1"
                                border
                                :disabled="noUpload.indexOf('07') !== -1"
                                ><span class="no_upload">7月（未上传）</span></el-checkbox
                              >
                              <el-checkbox
                                label="07"
                                v-if="noConnect.indexOf('07') !== -1"
                                border
                                :disabled="noConnect.indexOf('07') !== -1"
                                ><span class="uploaded">7月（已交接）</span></el-checkbox
                              >
                              <el-checkbox
                                label="07"
                                v-if="canConnect.indexOf('07') !== -1"
                                border
                                style="color: #67c23a"
                                >7月（待交接)</el-checkbox
                              >
                            </el-col>
                            <el-col :span="7" :offset="1">
                              <el-checkbox
                                label="08"
                                v-if="noUpload.indexOf('08') !== -1"
                                border
                                :disabled="noUpload.indexOf('08') !== -1"
                                ><span class="no_upload">8月（未上传）</span></el-checkbox
                              >
                              <el-checkbox
                                label="08"
                                v-if="noConnect.indexOf('08') !== -1"
                                border
                                :disabled="noConnect.indexOf('08') !== -1"
                                ><span class="uploaded">8月（已交接）</span></el-checkbox
                              >
                              <el-checkbox
                                label="08"
                                v-if="canConnect.indexOf('08') !== -1"
                                border
                                style="color: #67c23a"
                                >8月（待交接)</el-checkbox
                              >
                            </el-col>
                            <el-col :span="7" :offset="1">
                              <el-checkbox
                                label="09"
                                v-if="noUpload.indexOf('09') !== -1"
                                border
                                :disabled="noUpload.indexOf('09') !== -1"
                                ><span class="no_upload">9月（未上传）</span></el-checkbox
                              >
                              <el-checkbox
                                label="09"
                                v-if="noConnect.indexOf('09') !== -1"
                                border
                                :disabled="noConnect.indexOf('09') !== -1"
                                ><span class="uploaded">9月（已交接）</span></el-checkbox
                              >
                              <el-checkbox
                                label="09"
                                v-if="canConnect.indexOf('09') !== -1"
                                border
                                style="color: #67c23a"
                                >9月（待交接)</el-checkbox
                              >
                            </el-col>
                          </el-col>
                          <el-col :span="24" class="col-margin">
                            <el-col :span="7">
                              <el-checkbox
                                label="10"
                                v-if="noUpload.indexOf('10') !== -1"
                                border
                                :disabled="noUpload.indexOf('10') !== -1"
                                ><span class="no_upload"
                                  >10月（未上传）</span
                                ></el-checkbox
                              >
                              <el-checkbox
                                label="10"
                                v-if="noConnect.indexOf('10') !== -1"
                                border
                                :disabled="noConnect.indexOf('10') !== -1"
                                ><span class="uploaded">10月（已交接）</span></el-checkbox
                              >
                              <el-checkbox
                                label="10"
                                v-if="canConnect.indexOf('10') !== -1"
                                border
                                style="color: #67c23a"
                                >10月（待交接)</el-checkbox
                              >
                            </el-col>
                            <el-col :span="7" :offset="1">
                              <el-checkbox
                                label="11"
                                v-if="noUpload.indexOf('11') !== -1"
                                border
                                :disabled="noUpload.indexOf('11') !== -1"
                                ><span class="no_upload"
                                  >11月（未上传）</span
                                ></el-checkbox
                              >
                              <el-checkbox
                                label="11"
                                v-if="noConnect.indexOf('11') !== -1"
                                border
                                :disabled="noConnect.indexOf('11') !== -1"
                                ><span class="uploaded">11月（已交接）</span></el-checkbox
                              >
                              <el-checkbox
                                label="11"
                                v-if="canConnect.indexOf('11') !== -1"
                                border
                                style="color: #67c23a"
                                >11月（待交接)</el-checkbox
                              >
                            </el-col>
                            <el-col :span="7" :offset="1">
                              <el-checkbox
                                label="12"
                                v-if="noUpload.indexOf('12') !== -1"
                                border
                                :disabled="noUpload.indexOf('12') !== -1"
                                ><span class="no_upload"
                                  >12月（未上传）</span
                                ></el-checkbox
                              >
                              <el-checkbox
                                label="12"
                                v-if="noConnect.indexOf('12') !== -1"
                                border
                                :disabled="noConnect.indexOf('12') !== -1"
                                ><span class="uploaded">12月（已交接）</span></el-checkbox
                              >
                              <el-checkbox
                                label="12"
                                v-if="canConnect.indexOf('12') !== -1"
                                border
                                style="color: #67c23a"
                                >12月（待交接)</el-checkbox
                              >
                            </el-col>
                          </el-col>
                        </el-checkbox-group>
                      </el-col>
                    </el-col>
                  </el-col>
                  <el-col :span="24" class="m-label">
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="交接类型" placement="top">
                        <span class="count_style" style="display: inherit"
                          >交接类型：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-radio-group v-model="addVoucher.connect_type" size="mini">
                        <el-radio label="1" border>快递交接</el-radio>
                        <el-radio label="2" border>当面交接</el-radio>
                      </el-radio-group>
                    </el-col>
                  </el-col>
                  <el-col
                    :span="24"
                    class="m-label"
                    style="padding: 10px 0 10px 0"
                    v-if="addVoucher.connect_type === '2'"
                  >
                    <el-col :span="4">凭证交接单：</el-col>
                    <el-col :span="20" class="m-label">
                      <el-card shadow="hover">
                        <el-upload
                          multiple
                          ref="upload"
                          action="#"
                          accept="image/png, image/jpeg, image/gif"
                          :limit="5"
                          :on-preview="handleVoucherPreview"
                          :on-change="handleVoucherChange"
                          :on-remove="handleVoucherRemove"
                          :file-list="voucherList"
                          list-type="picture"
                          :auto-upload="false"
                        >
                          <el-link slot="trigger" type="primary"
                            >上传截图(最多可上传5张)</el-link
                          >
                        </el-upload>
                      </el-card>
                    </el-col>
                    <el-col :span="20" :offset="4" v-if="addVoucher.connect_type === '2'">
                      <el-input
                        v-paste="handleVoucherParse"
                        type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图"
                      />
                    </el-col>
                  </el-col>
                  <el-col
                    :span="24"
                    class="m-label"
                    v-if="addVoucher.connect_type === '1'"
                  >
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="快递公司" placement="top">
                        <span class="count_style" style="display: inherit"
                          >快递公司：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-col :span="11">
                        <el-select
                          v-model="addVoucher.exp_com"
                          placeholder="请选择快递公司"
                          size="mini"
                          clearable
                        >
                          <el-option value="SFEXPRESS" label="顺丰"></el-option>
                          <el-option value="STO" label="申通"></el-option>
                          <el-option value="YTO" label="圆通"></el-option>
                          <el-option value="ZTO" label="中通"></el-option>
                          <el-option value="HTKY" label="汇通"></el-option>
                          <el-option value="YUNDA" label="韵达"></el-option>
                          <el-option value="TTKDEX" label="天天"></el-option>
                          <el-option value="JD" label="京东快递"></el-option>
                          <el-option value="ZJS" label="宅急送"></el-option>
                          <el-option value="CHINAPOST" label="EMS"></el-option>
                          <el-option value="INTMAIL" label="EMS国际"></el-option>
                          <el-option value="DEPPON" label="德邦"></el-option>
                        </el-select>
                      </el-col>
                    </el-col>
                  </el-col>
                  <el-col
                    :span="24"
                    class="m-label"
                    v-if="addVoucher.connect_type === '1'"
                  >
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="快递单号" placement="top">
                        <span class="count_style" style="display: inherit"
                          >快递单号：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-col :span="11">
                        <el-input
                          v-model="addVoucher.exp_num"
                          size="mini"
                          type="text"
                          placeholder="请输入快递单号"
                        />
                      </el-col>
                    </el-col>
                  </el-col>
                  <el-col
                    :span="24"
                    class="m-label"
                    v-if="addVoucher.connect_type === '1'"
                  >
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="收（发）件人手机" placement="top">
                        <span class="count_style" style="display: inherit"
                          >收（发）件人手机：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-col :span="11">
                        <el-input
                          v-model="addVoucher.exp_phone"
                          size="mini"
                          type="text"
                          placeholder="请输入收（发）件人手机"
                        />
                      </el-col>
                    </el-col>
                  </el-col>
                  <el-col :span="24" class="m-label">
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="交接内容" placement="top">
                        <span class="count_style" style="display: inherit"
                          >交接内容：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-input
                        v-model="addVoucher.remark"
                        type="textarea"
                        placeholder="请输入备注或者凭证交接内容"
                      />
                    </el-col>
                  </el-col>
                </el-row>
                <el-row class="m-label">
                  <el-col :span="24" class="text-r">
                    <el-button type="primary" size="mini" @click="handleAddVoucherConnect"
                      >添加</el-button
                    >
                  </el-col>
                  <el-col style="height: 50px"></el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      title="聊天记录"
      :visible.sync="chatDrawer"
      direction="rtl"
      :before-close="handleChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <chat :chatId="chatId" :chatName="chatName"></chat>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="企业微信聊天记录"
      :visible.sync="wxChatDrawer"
      direction="rtl"
      :before-close="handleWxChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat :chatId="wxWorkChatId" :chatName="wxWorkchatName"></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="电话联系记录"
      :visible.sync="callLogsDrawer"
      direction="rtl"
      :before-close="handleCallLogsBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs
            :company="company"
            :phone="callPhone"
            :phone1="callPhone1"
            :phone2="callPhone2"
            :phone3="callPhone3"
          ></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="聊天记录"
      :visible.sync="qyChatDrawer"
      direction="rtl"
      :before-close="handleQyChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <qy-group-chat :chatId="qyChatId" :chatName="qyChatName"></qy-group-chat>
      </div>
    </el-drawer>
    <!-- 支付人详情及公司情况 开始 -->
    <el-drawer
      title="支付人详情及公司概况"
      :visible.sync="handlePayerContentDrawer"
      direction="rtl"
      :before-close="handleClose"
      size="50%"
      class="PayerContent"
    >
      <!-- 组件调用 -->
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <userwith-order
            :PayerData="userData"
            :ThreadData="ThreadData"
            :PayerCompanyData="PayerCompanyData"
            :userOrderData="userOrderData"
          ></userwith-order>
        </el-row>
      </div>
      <!-- 组件调用 -->
    </el-drawer>
    <!-- 支付人详情及公司情况 结束 -->
    <!-- 沟通记录弹窗 开始-->
    <el-drawer
      title="沟通记录"
      :visible.sync="chatRecordDrawer"
      direction="rtl"
      :before-close="handleChatRecordBeforeClose"
      size="40%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <chat-record :threadId="threadId"></chat-record>
        </el-row>
      </div>
    </el-drawer>
    <!-- 沟通记录弹窗 结束-->
  </el-container>
</template>

<script>
import Chat from "common/Chat";
import WxWorkChat from "common/WxWorkChat";
import CallLogs from "common/CallLogs";
import QyGroupChat from "common/QyGroupChat";
import TaxAdvice from "common/TaxAdvice";
import UserwithOrder from "common/UserWithOrder";
import ChatRecord from "common/ChatRecord";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "Voucher",
  components: {
    Chat,
    WxWorkChat,
    CallLogs,
    QyGroupChat,
    TaxAdvice,
    UserwithOrder,
    ChatRecord,
  },
  data() {
    return {
      handlePayerContentDrawer: false,
      ThreadData: {},
      userData: {},
      // 客户线索沟通记录弹窗
      chatRecordDrawer: false,
      // 沟通子组件传递的线索id
      threadId: null,
      PayerCompanyData: [],
      userOrderData: [],
      payerShowTab: "1",
      companyInfoDrawer: false,
      formData: null,
      list_year: "",
      list_month: "",
      companyName: "",
      allusers: [],
      companies: [],
      batchArr: [],
      vouchers: [],
      infoRecord: [],
      voucherList: [],
      licenseList: [],
      noUpload: [],
      noConnect: [],
      canConnect: [],
      activeName: 1,
      showTabPane: "first",
      loading: false,
      searchVisible: false,
      serviceDrawer: false,
      uploadingDrawer: false,
      categoryIndrawer: false,
      adviceComId: null,
      adviceComName: null,
      searchArr: {
        cid: "",
        dateTime: "",
        is_connect: "",
        leader_id: "",
        acc_id: "",
        ass_id: "",
        saler_id: "",
        advisory_id: "",
        invoice_id: "",
        is_bind: "",
        is_subscribe: "",
        archives: "",
      },
      addForm: {
        month: "",
        remark: "",
        type: null,
        cid: null,
        index: null,
      },
      addVoucher: {
        index: null,
        cid: null,
        year: "",
        months: [],
        connect_type: null,
        exp_com: "",
        exp_num: "",
        exp_phone: "",
        remark: "",
      },
      addRules: {
        month: [
          {
            required: true,
            message: "请选择月份",
            trigger: "blur",
          },
        ],
      },
      informForm: {
        cid: null,
        month: "",
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30, // 每页显示条数
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      imgPath: "https://www.qiyehuo.com/uploads/adminuser/",
      chatDrawer: false,
      chatId: "",
      chatName: "",
      wxChatDrawer: false,
      wxWorkChatId: "",
      wxWorkchatName: "",
      callLogsDrawer: false,
      company: "",
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      qyChatDrawer: false,
      qyChatId: "",
      qyChatName: "",
      uploadHeader: { Authorization: localStorage.token },
      additionalData: { value: '无', label: 'NULL' },
    };
  },
  watch: {
    "addVoucher.connect_type": function (value) {
      if (value === "1") {
        this.voucherList = [];
      }
      if (value === "2") {
        this.addVoucher.exp_com = "";
        this.addVoucher.exp_num = "";
        this.addVoucher.exp_phone = "";
      }
    },
  },
  computed: {
    pageData: function () {
      return this.vouchers;
    },
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }

      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
    allusersAddition() {
      return [...this.allusers, this.additionalData]
    }
  },
  methods: {
    vForExport() {
      this.$axios
        .post("api/voucher/export", this.searchStr, { responseType: "blob" })
        .then(({ data }) => {
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "凭证封面.xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 10);
        })
        .catch();
    },
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    // 展示支付人信息及公司情况
    handleShowPayerContent(row) {
      this.ThreadData = row.user.publicthread;
      this.userData = row.user;
      this.PayerCompanyData = row.user.company;
      if (this.PayerCompanyData.length !== 0) {
        for (let item of this.PayerCompanyData) {
          item.business_man = row.user.business.username;
        }
      }
      this.handelOpenUserOrder(row.user);
      this.handlePayerContentDrawer = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.PayerData = [];
          this.handlePayerContentDrawer = false;
          this.payerShowTab = "1";
          done();
        })
        .catch((_) => {});
    },
    // 控制用户关联订单信息展示与隐藏
    handelOpenUserOrder(row) {
      this.$axios.post("/api/customer/get_customer_order", { id: row.id }).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.userOrderData = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 打开当前客户手机号对应的沟通记录
    handleShowChatRecordOpen(threadId) {
      this.chatRecordDrawer = true;
      setTimeout(() => {
        this.threadId = threadId;
      });
    },
    // 关闭沟通记录弹窗
    handleChatRecordBeforeClose(done) {
      this.chatRecordDrawer = false;
      this.threadId = null;
      done();
    },
    getPageDatas() {
      this.$axios
        .get(
          "/api/voucher?page=" +
            this.pageOption.currentPage +
            "&limit=" +
            this.pageOption.pageSize +
            this.searchStr
        )
        .then((res) => {
          const { data } = res;
          this.vouchers = data.data.list.data;
          this.list_month = data.data.month;
          this.list_year = data.data.year;
          this.allusers = data.data.users;
          this.pageOption.total = data.data.list.total;
          this.pageOption.currentPage = data.data.list.current_page;
          this.batchArr = [];
          for (let key in this.vouchers) {
            this.batchArr.push(this.vouchers[key].id);
          }
        });
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
},
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getPageDatas();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getPageDatas();
    },
    handleUploadImg(row, index, type) {
      this.row = row;
      this.addForm.index = index;
      this.addForm.cid = row.id;
      this.addForm.type = type;
      this.addForm.month = this.list_month;
      this.licenseList = [];
      this.formData = null;
      this.formData = new FormData();
      this.uploadingDrawer = true;
    },
    handleAddClose(done) {
      this.$refs["addForm"].resetFields();
      this.licenseList = [];
      done();
      this.formData = null;
    },
    pickerDataChangeUpload(val) {
      if (val) {
        this.addForm.month = val;
      } else {
        this.addForm.month = "";
      }
    },
    handleLicensePreview(file) {},
    handleLicenseChange(file, fileList) {
      this.licenseList = fileList;
    },
    handleLicenseRemove(file, fileList) {
      this.licenseList = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleParse(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList.length < 5) {
            that.licenseList.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    submitAddUpload(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.licenseList.length === 0) {
            this.$message.error("请上传申报图片");
            return;
          }
          this.licenseList.forEach((file) => this.formData.append("file[]", file.raw));
          for (let key in this.addForm) {
            this.formData.append(key, this.addForm[key]);
          }
          this.$axios.post("/api/voucher/list", this.formData).then((res) => {
            let { data } = res;
            if (data.code === 0) {
              this.$message.success(data.msg);
              if (data.data.state && !Array.isArray(data.data.state)) {
                this.vouchers[this.addForm.index].voucher_state.unshift(data.data.state);
              }
              this.vouchers[this.addForm.index].voucher_list.unshift(data.data.record);
              this.uploadingDrawer = false;
              this.$refs["addForm"].resetFields();
              this.licenseList = [];
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    handleVoucherPreview(file) {},
    handleVoucherChange(file, fileList) {
      this.voucherList = fileList;
    },
    handleVoucherRemove(file, fileList) {
      this.voucherList = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.voucherList.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addVoucher[key]);
      }
    },
    handleVoucherParse(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.voucherList.length < 5) {
            that.voucherList.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleOpen(cid, cname, row, tag = "first") {
      this.showTabPane = tag;
      this.companyName = cname;
      this.addVoucher.year = this.list_year;
      this.addVoucher.cid = cid;
      this.getRecordDatas(cid);
      this.handleChangeYear();
      this.clearAddVoucher();
      this.serviceDrawer = true;
      this.voucherList = [];
      this.formData = null;
      this.formData = new FormData();
    },
    handleCloseIn(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          setTimeout(() => {
            this.adviceComId = null;
            // this.$refs.categoryForm.resetFields()
            // this.$refs.uploadMutiple.clearFiles()
            this.needUrl = [];
          });
          done();
        })
        .catch((_) => {});
    },
    getRecordDatas(cid) {
      this.$axios.get("/api/voucher/records/" + cid).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.infoRecord = data.data.records;
        }
      });
    },
    handleChangeYear() {
      this.$axios
        .get(
          "/api/voucher/months?cid=" +
            this.addVoucher.cid +
            "&year=" +
            this.addVoucher.year
        )
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.addVoucher.months = [];
            this.noUpload = [];
            this.noConnect = [];
            this.canConnect = [];
            this.noUpload = data.data.no_upload;
            this.noConnect = data.data.no_connect;
            this.canConnect = data.data.can_connect;
          }
        });
    },
    handleAddVoucherConnect() {
      if (!this.addVoucher.cid) {
        this.$message.error("公司不能为空");
        return false;
      }
      if (!this.addVoucher.year) {
        this.$message.error("请选择交接年份");
        return false;
      }
      if (this.addVoucher.months.length <= 0) {
        this.$message.error("请选择交接月份");
        return false;
      }
      if (!this.addVoucher.connect_type) {
        this.$message.error("请选择交接类型");
        return false;
      }
      if (this.addVoucher.connect_type === "1") {
        if (!this.addVoucher.exp_com) {
          this.$message.error("请选择快递公司");
          return false;
        }
        if (!this.addVoucher.exp_num) {
          this.$message.error("请输入快递单号");
          return false;
        }
        if (!this.addVoucher.exp_phone) {
          this.$message.error("请输入发（收）件人手机号码");
          return false;
        }
      }
      if (this.addVoucher.connect_type === "2") {
        if (this.voucherList.length === 0) {
          this.$message.error("请上传凭证交接单图片");
          return;
        }
        this.voucherList.forEach((file) => this.formData.append("file[]", file.raw));
      }
      for (let key in this.addVoucher) {
        this.formData.append(key, this.addVoucher[key]);
      }

      this.$axios.post("/api/voucher/connect", this.formData).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          this.addVoucher.cid = null;
          this.addVoucher.year = "";
          this.clearAddVoucher();
          this.serviceDrawer = false;
          this.voucherList = [];
          this.formData = null;
          this.getPageDatas();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    clearAddVoucher() {
      this.addVoucher.index = null;
      this.addVoucher.months = [];
      this.addVoucher.connect_type = null;
      this.addVoucher.exp_com = "";
      this.addVoucher.exp_num = "";
      this.addVoucher.exp_phone = "";
      this.addVoucher.remark = "";
    },
    handleDateTimeChange(val) {
      this.pageOption.currentPage = 1;
      this.getPageDatas();
    },
    handleCompanyChange(val) {
      this.pageOption.currentPage = 1;
      this.getPageDatas();
    },
    remoteCompanyMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleSearchGetData() {
      this.searchVisible = false;
      this.getPageDatas();
    },
    handleClearSearchGetData() {
      this.searchArr.leader_id = "";
      this.searchArr.acc_id = "";
      this.searchArr.ass_id = "";
      this.searchArr.saler_id = "";
      this.searchArr.advisory_id = "";
      this.searchArr.invoice_id = "";
      this.searchArr.is_bind = "";
      this.searchArr.is_subscribe = "";
      this.searchArr.archives = "";
      this.searchVisible = false;
      this.getPageDatas();
    },
    handleChatOpen(chat, companyName) {
      if (chat) {
        this.chatDrawer = true;
        setTimeout(() => {
          this.chatId = chat.chat_id;
          this.chatName = companyName;
        });
      }
    },
    handleChatBeforeClose(done) {
      this.chatId = "";
      this.chatName = "";
      done();
    },
    handleWxChatOpen(chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxWorkchatName = companyName;
        });
      }
    },
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    copyStr(needStr) {
      let oInput = document.createElement("input");
      oInput.value = needStr;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "已成功复制到剪切板",
        type: "success",
      });
      oInput.remove();
    },
    handleOpenAdvice(id, cname) {
      this.adviceComId = id;
      this.adviceComName = cname;
      this.categoryIndrawer = true;
    },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true;
      setTimeout(() => {
        this.company = row.company_name;
        if (row.user) this.callPhone.push(row.user.phone);
        if (row.docking_phone) this.callPhone3.push(row.docking_phone);
        if (row.orders.length > 0) {
          for (var i = 0; i < row.orders.length; i++) {
            if (
              row.orders[i].customer_phone &&
              this.callPhone1.indexOf(row.orders[i].customer_phone) === -1
            )
              this.callPhone1.push(row.orders[i].customer_phone);
            if (
              row.orders[i].corporate_phone &&
              this.callPhone2.indexOf(row.orders[i].corporate_phone) === -1
            )
              this.callPhone2.push(row.orders[i].corporate_phone);
          }
        }
      });
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    handleQyChatOpen(chat, chatName) {
      if (chat) {
        this.qyChatDrawer = true;
        setTimeout(() => {
          this.qyChatId = chat.chat_id;
          this.qyChatName = chatName;
        });
      }
    },
    handleQyChatBeforeClose(done) {
      this.qyChatId = "";
      this.qyChatName = "";
      done();
    },
    submitBind(options) {
      let formData = new FormData();
      formData.append("file", options.file);
      this.$axios
        .post("/api/admin/export_accounts", formData, { responseType: "blob" })
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "记账报税材料.xls";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 100);
        });
    },
  },
  mounted() {
    this.getPageDatas();
  },
};
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
@import '~styles/icon.styl'
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.voucher >>> .success-row
  background: #f0f9eb
.voucher >>> .el-table__header th
  color: #333
  background-color: #ecf4ff
.el-drawer__wrapper >>> .el-timeline-item__wrapper
  top 0
.el-timeline-item__node--large
  width .4rem
  height .4rem
.public
  display flex
  width 100%;
  box-sizing border-box
.el-date-editor
  width: 100% !important
.mt-10
  margin-top: .2rem
.el-select, .el-cascader
  width: 100%
.image
  width 2rem
  height 2rem
  border-radius 3px
.el-checkbox
  width: 130px
  text-align: center
.col-margin
  margin: 5px 0 5px 0
.voucher
  padding: 1.42rem .4rem .4rem .4rem
  max-height: 100vh;
  .header-style
    z-index: 2;
    height: 110px !important;
    padding: 0 !important;
  .main-style
    z-index: 1;
    padding: 0px !important;
    overflow-y: auto;
  .footer-style
    text-align: right;
    .el-pagination
      padding-top: 10px;
  .drawer-content
    padding: 0 .4rem 0 .4rem
  .hide-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
  .text-r
    text-align: right
    margin: 15px 0 0 0
  .m-label
    line-height: .56rem
    margin: 3px 0 3px 0
  .popover_span
    .el-position
      font-family: Arial, "Microsoft Yahei", "Helvetica Neue", Helvetica, sans-serif;
  .count_style
    display: inline-block
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
  .icon-qingtonghuiyuan
    color: #E9935D;
  .icon-baiyinhuiyuan
    color: #E6E8FA
  .icon-huangjinhuiyuan
    color: #FFD32F;
  .icon-qingtong
    color: #40BBEC
  .icon-zuanshi
    color: #83A4FF;
  .icon-wangzhe
    color: #A8A8A8
  .el-icon-chat-dot-square
    color: #88D023
.top-line
  color: #409EFF
  font-weight: bold
.no_upload
  color: #f56c6c;
  opacity: 0.6
.uploaded
  color: #e6a23c;
  opacity: 0.6
.el-drawer__wrapper >>> .el-drawer__header span
  color: #4c87fc
  font-size 0.36rem
  font-weight 400
.el-drawer__wrapper >>> .el-timeline-item__wrapper
  top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.footer-style
  position: fixed
  bottom: 0
  left: 0
  height: 80px
  background: #fff
  width: 100%
  z-index: 2
.pagination-style
  padding-top: 15px
  text-align: right
</style>



// WEBPACK FOOTER //
// src/pages/voucher/Voucher.vue